import { groq } from '#imports';

export function getQuery() {
  return groq`*[_type == "highlightedNewsCard"]{
    showHighlightNews,
    card->{slug, title, _createdAt, _updatedAt},
  }`;
}
